import { useEffect, useState } from "react";
import { apiUrl } from "../../common/api/config";
import useFetch from "../../global/hooks/useFetch";
import useMutation from "../../global/hooks/useMutation";

export const useAsset = (assetId) => {
  const [asset, setAsset] = useState(null);

  const {
    data,
    loading,
    error: fetchError,
    refetch: refetchAsset,
  } = useFetch(`/assets/${assetId}/`);

  useEffect(() => {
    if (data) {
      setAsset(data);
    }
  }, [data]);

  const {
    mutate: updateAssetMutation,
    loading: updating,
    error: updateError,
  } = useMutation(`/assets/${assetId}/`, "PUT");

  const {
    mutate: deleteAssetMutation,
    loading: deleting,
    error: deleteError,
  } = useMutation(`/assets/${assetId}/`, "DELETE");

  const updateAsset = async (assetData) => {
    try {
      const updated = await updateAssetMutation(assetData);
      return updated;
    } catch (error) {
      console.error("Error updating asset:", error);
    }
  };

  const deleteAsset = async () => {
    deleteAssetMutation();
  };

  const error = updateError || deleteError;

  useEffect(() => {
    if (error) {
      console.log(error.message);
    }
  }, [error]);

  return {
    asset,
    loading,
    fetchError,
    updateAsset,
    updating,
    deleteAsset,
    deleting,
    error,
    refetch: refetchAsset,
  };
};

export const getTopPerformingAssetsByImpressions = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(
      apiUrl + "/assets/top-performing-by-impressions/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      },
    );

    const responseData = await response.json();

    if (response.ok) {
      return responseData;
    } else {
      throw new Error(responseData.errors);
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getTopPerformingAssetsBySales = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(apiUrl + "/assets/top-performing-by-sales/", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });

    const responseData = await response.json();

    if (response.ok) {
      return responseData;
    } else {
      throw new Error(responseData.errors);
    }
  } catch (error) {
    throw new Error(error);
  }
};
